<template>
  <b-card no-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      show-empty
      empty-text="Henüz başvuru yok."
    >
      <template #cell(name)="data">
        <div>{{ data.item.name }}</div>
        <div class="text-muted font-small-2">
          {{ data.item.email }} · {{ data.item.phone }}
        </div>
      </template>
      <template #cell(filename)="data">
        <b-button
          v-if="data.item.filename"
          variant="flat-success"
          size="sm"
          :href="baseURL + '/media/hr_forms/' + data.item.filename"
          target="_blank"
        >
          <FeatherIcon icon="DownloadIcon" />
          CV
        </b-button>
        <span
          v-else
          class="text-muted"
        >-</span>
      </template>
      <template #cell(created)="data">
        {{ formatDate(data.item.created) }}
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-dropdown-buttons
            :primary-action="'/app/hr-forms/view/' + data.item.id"
            primary-text="Görüntüle"
            :data-id="data.item.id"
            :delete-action="removeData"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BPagination, BCardFooter, BButton,
} from 'bootstrap-vue'
import ListDropdownButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'HrFormsIndex',
  components: {
    BCard,
    BTable,
    BPagination,
    BCardFooter,
    BButton,
    ListDropdownButtons,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'name',
          label: 'AD SOYAD',
        },
        {
          key: 'filename',
          label: 'CV',
          thStyle: { width: '120px' },
        },
        {
          key: 'created',
          label: 'TARİH',
          thStyle: { width: '180px' },
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '200px' },
        },
      ],
      dataQuery: {
        select: [
          'hr_form.id AS id',
          'hr_form.name AS name',
          'hr_form.email AS email',
          'hr_form.phone AS phone',
          'hr_form.filename AS filename',
          'hr_form.created AS created',
        ],
        order_by: ['hr_form.id', 'DESC'],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['hrForms/dataList']
    },
    dataCounts() {
      return this.$store.getters['hrForms/dataCounts']
    },
    saveData() {
      return this.$store.getters['hrForms/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.perPage
      this.getDataList()
    },
    saveData(val) {
      this.showToast(val.status
        ? {
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        }
        : {
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    formatDate(value) {
      return value ? this.moment(value).format('DD.MM.YYYY HH:mm') : '-'
    },
    getDataList() {
      this.$store.dispatch('hrForms/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('hrForms/removeData', id)
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: params,
      })
    },
  },
}
</script>
